import { REGISTRATION_STATUSES } from 'api/auth/constants'
import { UserRoles } from 'constants/roles'
import { RootState } from 'redux/store'
import { CreationSource } from './types'
import { MigrationSectionsStatuses, RegistrationStatuses } from 'api/auth/types'

export const userDataSelector = (state: RootState) => state.authReducer.userData

export const errorMessageSelector = (state: RootState) =>
  state.authReducer.error?.message

export const errorCodeSelector = (state: RootState) =>
  state.authReducer.error?.code

export const userRoleSelector = (state: RootState) =>
  state.authReducer.userData.roles[0]

export const supplierCompanyIdSelector = (state: RootState) =>
  state.authReducer.userData.companyId

export const isOperatorSelector = (state: RootState) =>
  state.authReducer.userData?.roles[0] === UserRoles.Operator

export const isSupplierSelector = (state: RootState) =>
  state.authReducer.userData?.roles[0] === UserRoles.Supplier

export const authIsLoadedSelector = (state: RootState) =>
  state.authReducer.isLoaded

export const authIsLoadingSelector = (state: RootState) =>
  state.authReducer.isLoading

export const accountStatusSelector = (state: RootState) =>
  state.authReducer.userData.accountStatus

export const isReadyToApproveSelector = (state: RootState) =>
  (accountStatusSelector(state) === 'Registered' ||
    accountStatusSelector(state) === 'Pending') &&
  isOperatorSelector(state)

export const supplierCurrencySelector = (state: RootState) =>
  state.authReducer.userData.currency

export const menuSectionsNotCompletedSelector = (state: RootState) => {
  const prepareNotCompletedSections = (
    sectionsStatuses: MigrationSectionsStatuses | RegistrationStatuses
  ): string[] =>
    Object.entries(sectionsStatuses).reduce((acc, [key, status]) => {
      if (status === REGISTRATION_STATUSES.INCOMPLETE) {
        acc.push(key)
      }
      return acc
    }, [] as string[])

  let currentSectionsStatuses
  if (state.authReducer.userData.creationSource === CreationSource.Migrated) {
    currentSectionsStatuses =
      state.authReducer.userData.migrationSectionsStatuses
  } else {
    currentSectionsStatuses = state.authReducer.userData.sectionsStatuses
  }

  return currentSectionsStatuses
    ? prepareNotCompletedSections(currentSectionsStatuses)
    : null
}
export const isMigratedUserSelector = (state: RootState) =>
  state.authReducer.userData.creationSource === CreationSource.Migrated

export const isMigratedUserFlowSelector = (state: RootState) =>
  isMigratedUserSelector(state) && !isOperatorSelector(state)
